import React from 'react';
import { observer } from 'mobx-react-lite';
import dotsToCommas from 'utils/dotsToCommas';

const Dimensions = observer(({ width, height, length }) => {
  const isDimensions = length || width || height;
  if (!isDimensions) return null;

  return (
    <tr>
      <td className="pale">Габариты</td>
      <td>
        <span>
          {[
            length && `${dotsToCommas(length)}м`,
            width && `${dotsToCommas(width)}м`,
            height && `${dotsToCommas(height)}м`,
          ]
            .filter((el) => el)
            .join(' x ')}
        </span>
        <span className="transparent">
          {isDimensions &&
            ` (${[length && 'Д', width && 'Ш', height && 'В'].filter((el) => el).join('x')})`}
        </span>
      </td>
    </tr>
  );
});

export default Dimensions;
